import React from 'react';
import {formatDate} from 'utils/datetime';

import Table from 'components/Table';
import LinkText from 'components/LinkText';
import Money from 'components/Money';
import ExternalLink from 'components/ExternalLink';

import xeroIcon from './assets/xero-logo.svg';
import launchIcon from './assets/launch-47.svg';

import './styles.css';

const TransactionsTable = ({
  refund,
  parentObject,
  parentObjectLabel,
  onParentObjectClick
}) => {
  const {transaction} = refund;
  const date = parentObject.dateIssued || parentObject.createdAt;

  return (
    <div className="TransactionsTable">
      <Table>
        <Table.Header>
          <Table.HeaderItem
            heading={`${parentObjectLabel} NO`}
            className="parentObjectNumber"
          />
          <Table.HeaderItem
            heading={`${parentObjectLabel} Date`}
            className="parentObjectDate"
          />
          <Table.HeaderItem heading="Description" className="description" />
          <Table.HeaderItem
            heading={<img src={xeroIcon} alt="Xero Transaction" />}
            className="xeroTransaction"
          />
          <Table.HeaderItem
            heading={`${parentObjectLabel} Total`}
            className="parentObjectTotal"
          />
          <Table.HeaderItem
            heading="Amount applied"
            className="amountApplied"
          />
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>
              <LinkText onClick={() => onParentObjectClick(parentObject)}>
                {parentObject.number}
              </LinkText>
            </Table.Cell>
            <Table.Cell>{formatDate(date)}</Table.Cell>
            <Table.Cell>{parentObject.description}</Table.Cell>
            <Table.Cell>
              {refund.xeroId && (
                <ExternalLink href={refund.xeroLink} targetBlank>
                  <img src={launchIcon} alt="Launch Icon" />
                </ExternalLink>
              )}
            </Table.Cell>
            <Table.Cell>
              <Money amount={parentObject.totalIncludingTax} />
            </Table.Cell>
            <Table.Cell>
              <Money amount={transaction.amount} />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </div>
  );
};

export default TransactionsTable;
